import { useMutation, useQueryClient } from '@tanstack/react-query';
import discountsApi from '@/features/dashboard/discounts/api/discountsApi.ts';
import { discountsApiQueryKeys } from '@/features/dashboard/discounts/api/discountsApi.queryKeys.ts';
import { toast } from 'sonner';

export default function useCreateDiscount() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: discountsApi.create,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: discountsApiQueryKeys.all(),
      });
      toast.success('Zniżka została utworzona');
    },
    onError: (error: Error) => {
      toast.error('Wystąpił błąd', {
        description: error.message || 'Wystąpił błąd podczas tworzenia zniżki.',
      });
    },
  });
}
